import React from "react";
import { Spinner } from "react-bootstrap";

const GenerateReportForm = ({
  campaignId,
  setCampaignId,
  isGenerating,
  onGenerate,
  status,
}) => (
  <>
    <div className="mb-4">
      <label htmlFor="campaign_id" className="form-label">
        Campaign ID
      </label>
      <input
        id="campaign_id"
        type="text"
        className="form-control"
        value={campaignId}
        placeholder="Enter campaign ID (e.g., 12345)"
        onChange={(e) => setCampaignId(e.target.value)}
        disabled={isGenerating}
      />
    </div>

    <button onClick={onGenerate} className="btn btn-primary w-100" disabled={isGenerating}>
      {isGenerating ? (
        <>
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            className="me-2"
          />
          Generating...
        </>
      ) : (
        "Generate Report"
      )}
    </button>

    {status.message && (
      <div
        className={`alert alert-${status.type === "success" ? "success" : "danger"} mt-3`}
      >
        {status.message}
      </div>
    )}
  </>
);

export default GenerateReportForm;
